export default __webpack_public_path__ + "static/media/yo_9.a810c25f.mp3";